<template>
<el-dialog title="请选择项目" width="80%" :visible.sync="viewData.visible" append-to-body>
    <!-- <div class=""> -->
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
        <el-form-item label="合同编码:">
            <el-input size="small" v-model="dataForm.contractCode" placeholder="合同编码" clearable @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item label="负责人(甲方代表):">
            <el-input size="small" v-model="dataForm.partyaRepresentive" placeholder="负责人" clearable @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item label="合同状态:">
            <el-select size="small" v-model="dataForm.contractStatus" placeholder="请选择状态" clearable @change="getDataList">
                <el-option v-for="item in CONTRACT_STATUS_VALUE" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <!-- <el-input size="small" v-model="dataForm.contractStatus" placeholder="合同状态" clearable @blur="getDataList"></el-input> -->
        </el-form-item>
        <el-form-item class="fr">
            <el-button size="small" @click="getDataList()" icon="el-icon-search">
                查询
            </el-button>
        </el-form-item>
    </el-form>
    <div v-loading="dataListLoading">
        <!-- <el-table :data="dataList" row-key="id" size="mini" bProject style="width: 100%;" :default-expand-all="false"  @current-change="currentChange" highlight-current-row border :header-cell-style="{background:'#f5f5f5'}"> -->
        <el-table :data="dataList" row-key="id" size="mini" bProject style="width: 100%; margin-bottom: 15px;" :default-expand-all="false" @current-change="currentChange" highlight-current-row border :header-cell-style="{background:'#f5f5f5'}">
            <el-table-column type="index" width="50" label="序号">
                <template slot-scope="scope">
                    {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                </template>
            </el-table-column>
            <el-table-column prop="contractCode" header-align="center" align="left" label="合同编码:" width="150">
            </el-table-column>
            <el-table-column prop="contractName" header-align="center" align="left" label="合同名称" width="150">
            </el-table-column>
            <el-table-column prop="contractType" header-align="center" align="left" label="合同类型" width="150">
                <template slot-scope="scope">
                    {{ CONTRACT_TYPE_VALUE(scope.row.contractType) }}
                </template>
            </el-table-column>
            <el-table-column prop="contractStatus" header-align="center" align="center" label="合同状态" width="150">
                <template slot-scope="scope">
                    {{ getContactStatusByValue(scope.row.contractStatus) }}
                </template>
            </el-table-column>
            <el-table-column prop="purchasePartya" header-align="center" align="left" label="采购方甲方" width="150">
            </el-table-column>
            <el-table-column prop="partyaRepresentive" header-align="center" align="left" label="甲方代表" width="150">
            </el-table-column>
            <el-table-column prop="partyaSignDate" header-align="center" align="right" label="甲方签订日期" :formatter="dateFormat" width="170">
            </el-table-column>
            <el-table-column prop="supplierPartyb" header-align="center" align="left" label="供应商乙方" width="150">
            </el-table-column>
            <el-table-column prop="partybRepresentive" header-align="center" align="left" label="乙方代表" width="150">
            </el-table-column>
            <el-table-column prop="partybSignDate" header-align="center" align="right" label="乙方签订日期" :formatter="dateFormat" width="170">
            </el-table-column>
            <el-table-column prop="partybCode" header-align="center" align="left" label="乙方编码" width="150">
            </el-table-column>
            <el-table-column prop="createTime" header-align="center" align="right" label="创建时间" :formatter="dateFormat" width="170">
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20,50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        <el-row :gutter="40">
            <el-col :span="24" style="text-align: right">
                <el-button size="small" @click="viewData.visible = false">
                    取消
                </el-button>
                <!-- 询价中 -->
                <el-button size="small" plain type="primary" @click="confirm()">
                    确认
                </el-button>
            </el-col>
        </el-row>
    </div>
</el-dialog>
</template>

<script>
import {
    CONTRACT_STATUS_VALUE,
    getCONTRACT_TYPE_VALUE,
    getCONTRACT_STATUS_VALUE,
} from "@/utils/const";
import {
    DIALOG_CLOSED_TYPE
} from "@/utils/const";
import {
    getContractList
} from "@/controller/contract";
import moment from "moment";
export default {
    data() {
        return {
            viewData: {
                visible: false,
                width: "",
            },
            documentClientHeight: document.documentElement["clientHeight"] - 250,
            dataForm: {
                contractCode: '',
                partyaRepresentive: '',
                contractStatus: '',
                purchasePartya: '',
                partybCode: '',
            },
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            CONTRACT_STATUS_VALUE: CONTRACT_STATUS_VALUE,
            getContactStatusByValue: getCONTRACT_STATUS_VALUE,
            CONTRACT_TYPE_VALUE: getCONTRACT_TYPE_VALUE,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
            userList: [],
            currentRow: {},
        };
    },
    mounted() {},
    activated() {
        this.getDataList();
    },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property];
            if (date == undefined) {
                return "";
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss");
        },
        // 获取数据列表
        getDataList() {
            // console.log(this.getDataList)
            this.dataListLoading = true;
            getContractList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                'contractCode': this.dataForm.contractCode,
                'partyaRepresentive': this.dataForm.partyaRepresentive,
                'contractStatus': this.dataForm.contractStatus,
                'purchasePartya': this.dataForm.purchasePartya,
                'partybCode': this.dataForm.partybCode,
            }).then((data) => {
                console.log(data, "data");
                if (data && data.code === "00") {
                    this.dataList = data.body.records;
                    this.totalPage = data.body.total;
                } else {
                    this.dataList = [];
                    this.totalPage = 0;
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false;
            });
        },
        projectStatusFormat: function (value) {
            if (!value) {
                return ''
            }
            return getLabelByValue(PROJECT_STATUS, value)
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        currentChange(currentRow) {
            console.log(currentRow);
            this.currentRow = currentRow;
        },
        open(param) {
            this.viewData.visible = true;
            this.dataForm.partybCode = param.partybCode
            this.getDataList();
        },
        onClosed(params) {
            console.log(params);
            return;
        },
        // 筛选按钮弹框取消
        cancel() {
            this.close();
        },
        close(option = DIALOG_CLOSED_TYPE.CLOSE) {
            if (!this.viewData.visible) {
                return;
            }
            if (this.multiple) {
                this.onClosed({
                    option,
                    sender: this,
                    data: this.userList,
                });
            } else {
                this.onClosed({
                    option,
                    sender: this,
                    data: this.currentRow,
                });
            }
            this.viewData.visible = false;
        },
        confirm() {
            this.close(DIALOG_CLOSED_TYPE.CONFIRM);
        },
        //动态控制class,修改项目状态文字颜色
        getStatusClass(status) {
            let className = ''
            switch (status) {
                case '0':
                    className = "text-danger"
                    break;
                case '1':
                    className = "text-success"
                    break;
                default:
                    className = ''
                    break;
            }
            return className
        }
    },
};
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

.linetext {
    white-space: pre-line;
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.mb15 {
    margin-bottom: 15px;
}

.mt10 {
    margin-top: 10px;
}

.el-table__body {
    tr.current-row>td {
        color: #fff;
        background-color: #409EFF !important;
    }
}
</style>
